import { SCol } from '@avalara/skylab-sdk/react';
import type { OfferFlow } from '../../../../../types/offers';
import IossCustomDetails from './ioss';
import LicensePrepCustomDetails from './license-preparation';

type Props = { offerFlow: OfferFlow };

const customOfferDetails = ({ offerFlow }: Props) => {
  switch (offerFlow) {
    case 'license-preparation':
      return (
        <SCol span='12'>
          <LicensePrepCustomDetails />
        </SCol>
      );
    case 'ioss':
      return (
        <SCol span='12'>
          <IossCustomDetails />
        </SCol>
      );
    default:
      return null;
  }
};

export default customOfferDetails;
